const paletteGGV = {
  primary: {
    dark: "#060025",
    main: "#2C1B4B",
    light: "#524171"
  },
  custom: {
    secondary: "#EEBFD9"
  }
};

export default paletteGGV;
